<template>
	<div>
		<waiting v-if="loaded == false" />
		<BannerList
			v-if="loaded"
			listIcon="mdi-view-carousel"
			listTitle="배너 관리"
			:items="items"
			@registItem="registItem"
			@modifyItem="modifyItem"
			@deleteItem="deleteItem"
		></BannerList>
	</div>
</template>

<script>
	export default {
		name: 'BannerManager',
		props: {},
		data: () => ({
			items: [],
			loaded: false,
		}),
		mounted: async function() {
			this.items = await this.$database.loadBanners();
			this.loaded = true;
		},
		methods: {
			async registItem(item) {
				const currentTimestamp = this.$database.currentTimestamp();

				item.createAt = currentTimestamp;
				item.updateAt = currentTimestamp;

				await this.$database.addBanner(item);
				this.loaded = false;
				this.items = await this.$database.loadBanners();
				this.loaded = true;
			},
			async modifyItem(item) {
				const currentTimestamp = this.$database.currentTimestamp();
				item.updateAt = currentTimestamp;

				await this.$database.modifyBanner(item.id, item);
				this.loaded = false;
				this.items = await this.$database.loadBanners();
				this.loaded = true;
			},
			async deleteItem(id) {
				await this.$database.deleteBanner(id);
				this.loaded = false;
				this.items = await this.$database.loadBanners();
				this.loaded = true;
			},
		},
	};
</script>

<style scoped></style>
